export default __webpack_public_path__ + "static/media/cookingTime.9c85c92a.png";